import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02494c56"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onKeydown"]
const _hoisted_2 = { class: "grid grid-nogutter" }
const _hoisted_3 = { class: "col-12 md:col-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "名前、予約ID", -1))
const _hoisted_5 = { class: "col-12 md:col-3 md:pl-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "予約形態", -1))
const _hoisted_7 = { class: "col-12 md:col-3 md:pl-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "ステータス", -1))
const _hoisted_9 = { class: "col-12 md:col-3 md:pl-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "メニュー", -1))
const _hoisted_11 = { class: "grid grid-nogutter mt-5" }
const _hoisted_12 = { class: "col-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "フリガナ", -1))
const _hoisted_14 = { class: "col-3 ml-4" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "電話番号", -1))
const _hoisted_16 = { class: "grid grid-nogutter mt-5" }
const _hoisted_17 = { class: "col-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "予約日時", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ml-5",
  style: {"font-size":"25px"}
}, "~", -1))
const _hoisted_20 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_21 = { class: "col-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, " ", -1))
const _hoisted_23 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_24 = { class: "col-6" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, " ", -1))

import { ref, onBeforeMount, inject } from "vue";
import { MaybeRefOrGetter } from "@vueuse/core";
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";
import Calendar from "primevue/calendar";
import Button from "primevue/button";
import * as _ from "lodash";
import { MenuServices } from "@/clinic/services";
import { get, set } from "@vueuse/core";
import { ApiBaseReqParams, ApiMenuIndexRes, IMenu } from "@/clinic/typings";
import { BookingMenuSearchEnum, BookingStatusSearchOptions } from "@/clinic/typings/enums/booking";
import { useAsyncValidator } from "@vueuse/integrations/useAsyncValidator";
import rulesFn from "./rule";
import { Rule, Rules, ValidateError } from "async-validator";

type IFormRuleValidation = {
  customerStatus: string;
  startTime: string;
  endTime: string;
};

type IFieldValidator = {
  [key: string]: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'search-form',
  emits: ["search"],
  setup(__props, { emit }) {



const term = ref("");
const kanaTerm = ref("");
const phoneTerm = ref("");
const status = ref("");
const bookingType = ref("");
const startTime = ref();
const endTime = ref();
const menusOptions = ref([]);
const menus = ref<IMenu[]>([]);
const clinicId = ref();
const pass = ref(false);
const medicalMenuId = ref();
const errorFields = ref<Record<string, ValidateError[]>>({});
const errors = ref<ValidateError[]>([]);

// 予約形態フィルターのオプション（既存のRails API仕様に合わせて修正）
const BookingTypeFilterOptions = [
  { name: "-- 選ぶ --", value: "" },
  { name: "通常予約", value: "regular" },
  { name: "自由予約", value: "free_space" },
];

const onSearchClick = () => {
  const payload = {
    term: term.value,
    kanaTerm: kanaTerm.value,
    phoneTerm: phoneTerm.value,
    status: status.value,
    bookingType: bookingType.value,
    startTime: startTime.value,
    endTime: endTime.value,
    menusOptions: menusOptions.value,
    medicalMenuId: medicalMenuId.value,
  };
  emit("search", payload);
};

const loadMenus = async () => {
  const { data } = await MenuServices.getBookingMenus(await clinicIdParams());
  const { menus: menusData } = get(data) as unknown as ApiMenuIndexRes;
  const menusOption = [{ id: BookingMenuSearchEnum.id, name: BookingMenuSearchEnum.name }, ...menusData];
  set(menus, menusData);
  set(menusOptions, menusOption);
};

const initValidation = (value: IFieldValidator | any, rules: MaybeRefOrGetter<Record<string, Rule | Rules>>) =>
  useAsyncValidator(value, rules, { validateOption: { suppressWarning: true } });

const validate = async (fieldName?: string): Promise<boolean> => {
  const fieldTime = {
    startTime: get(startTime),
    endTime: get(endTime),
  } as IFormRuleValidation;
  const formRules = rulesFn(fieldTime);
  const [value, rules] = fieldName
    ? [{ [fieldName]: fieldName }, { [fieldName]: formRules[fieldName] }]
    : [fieldName, formRules];
  const { execute } = initValidation(value, rules);
  const { pass: fPass, errorFields: fErrorFields, errors: fErrors } = await execute();
  set(pass, get(fPass));
  set(errorFields, get(fErrorFields));
  set(errors, get(fErrors));
  return get(pass) as boolean;
};

const clinicIdParams = async (): Promise<ApiBaseReqParams> => ({ clinic_id: get(get(clinicId)) });

onBeforeMount(async () => {
  set(clinicId, inject("clinicId"));
  await loadMenus();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "box-search",
    onKeydown: _withKeys(onSearchClick, ["enter"])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_unref(InputText), {
          class: "p-float-label flex border-round w-11",
          placeholder: "名前、予約ID",
          modelValue: term.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((term).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_unref(Dropdown), {
          modelValue: bookingType.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((bookingType).value = $event)),
          options: BookingTypeFilterOptions,
          optionLabel: "name",
          optionValue: "value",
          class: "font-normal flex border-round w-11",
          placeholder: "-- 選ぶ --"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_unref(Dropdown), {
          modelValue: status.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((status).value = $event)),
          options: _unref(BookingStatusSearchOptions),
          optionLabel: "name",
          optionValue: "value",
          class: "font-normal flex shadow-none w-11",
          placeholder: "-- 選ぶ --"
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_unref(Dropdown), {
          modelValue: medicalMenuId.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((medicalMenuId).value = $event)),
          options: menusOptions.value,
          optionValue: "id",
          optionLabel: "name",
          class: "font-normal flex border-round w-11",
          placeholder: "-- 選ぶ --"
        }, null, 8, ["modelValue", "options"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_unref(InputText), {
          class: "p-float-label flex border-round w-11",
          placeholder: "フリガナ",
          modelValue: kanaTerm.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((kanaTerm).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode(_unref(InputText), {
          class: "p-float-label flex border-round w-11",
          placeholder: "電話番号",
          modelValue: phoneTerm.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((phoneTerm).value = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode(_unref(Calendar), {
          modelValue: startTime.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((startTime).value = $event)),
          class: "justify-content-end h-48 w-9",
          showIcon: "",
          showButtonBar: "",
          dateFormat: "yy/mm/dd",
          onDateSelect: _cache[7] || (_cache[7] = ($event: any) => (validate('startTime')))
        }, null, 8, ["modelValue"]),
        _hoisted_19,
        (errorFields.value?.startTime)
          ? (_openBlock(), _createElementBlock("small", _hoisted_20, _toDisplayString(_.head(errorFields.value.startTime)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createVNode(_unref(Calendar), {
          modelValue: endTime.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((endTime).value = $event)),
          class: "justify-content-end h-48 w-9",
          showIcon: "",
          showButtonBar: "",
          type: "date",
          dateFormat: "yy/mm/dd",
          onDateSelect: _cache[9] || (_cache[9] = ($event: any) => (validate('endTime')))
        }, null, 8, ["modelValue"]),
        (errorFields.value?.endTime)
          ? (_openBlock(), _createElementBlock("small", _hoisted_23, _toDisplayString(_.head(errorFields.value.endTime)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createVNode(_unref(Button), {
          label: "検索",
          class: "btn-search-booking text-center",
          onClick: onSearchClick
        })
      ])
    ])
  ], 40, _hoisted_1))
}
}

})